import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "../components/ImageOpt"
import Layout from "../components/layout"
import Seo from "../components/Seo/Seo"

import { Autoplay, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"

const BlogTemplate = props => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  const animFade3 = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 4,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const post = props.data.post

  const postData = props.data.wp.fluxDnaSettings.fluxDna
  const selectCards = postData.blogSingleSelectRelatedCards

  const bloguri = props.data.allWpPost.nodes.map(item => item.uri)
  const [nextPageCursor, setNextPageCursor] = useState("")
  const [prevPageCursor, setPrevPageCursor] = useState("")

  useEffect(() => {
    let currentPageIndex = bloguri.indexOf(post.uri)
    if (currentPageIndex > 1) {
      setPrevPageCursor(bloguri[currentPageIndex - 1])
    }

    if (currentPageIndex < bloguri.length - 1) {
      setNextPageCursor(bloguri[currentPageIndex + 1])
    }
  }, [bloguri, post.uri])

  return (
    <div className="fullPageanimation">
      <Layout props={props}>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
          >
            <div className="banner--wapper">
              <div
                className="h-[88px] smscreen2:h-[89px] opacity-0"
                aria-label="Kova"
              >
                Kove
              </div>
              <div className={`banner half-banner relative bg-stone `}>
                <div className="container-fluid h-full">
                  <div className="banner-inner relative h-full">
                    {post?.blogContent.bannerImage ? (
                      <div className="desk-img h-full mdscreen:h-full relative block">
                        <ImageOpt
                          imgData={post.blogContent.bannerImage.mediaItemUrl}
                          width={1440}
                          height={700}
                          imgAlt={post.blogContent.bannerImage.altText}
                          imgLoad="lazy"
                          imgClass="w-full h-full object-cover"
                        />
                      </div>
                    ) : (
                      <div className="desk-img h-full mdscreen:h-full relative block">
                        <ImageOpt
                          imgData={post.featuredImage.node.mediaItemUrl}
                          width={1440}
                          height={700}
                          imgAlt={post.featuredImage.node.altText}
                          imgLoad="lazy"
                          imgClass="w-full h-full object-cover"
                        />
                      </div>
                    )}

                    <div className="absolute bottom-0 pb-120 lgscreen:pb-50 z-10 text-center w-full px-30">
                      <motion.p
                        variants={animFade}
                        className="preheading mb-10 lgscreen:mb-15"
                      >
                        <span className="font-ositalic text-16 text-white-100">
                          Our Journal
                        </span>
                      </motion.p>

                      {post?.title && (
                        <div className="title-white w-full max-w-[80%] mx-auto">
                          <motion.h1 variants={animFade}>
                            {post.title}
                          </motion.h1>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="blog-single-content bg-tan bg-opacity-30">
              <div className="container-fluid">
                <div className="bg-white-100">
                  <div className="w-[890px] lgscreen:w-full max-w-[1100px] lgscreen:px-20 mx-auto text-center top-info py-50">
                    {post?.date && (
                      <motion.div
                        variants={animFade}
                        className="flex flex-wrap items-center justify-center gap-x-[5px]"
                      >
                        <img
                          src="/images/edit_calendar.svg"
                          className="relative -top-2"
                          width={12}
                          height={12}
                          loading="lazy"
                          alt="Event"
                        />
                        <span className="font-ositalic text-13">
                          {post.date}
                        </span>
                      </motion.div>
                    )}

                    <motion.div
                      variants={animFade}
                      className="post-content-top mt-10"
                    >
                      {post?.excerpt && <>{parse(post.excerpt)}</>}
                    </motion.div>
                  </div>
                  {post?.content && (
                    <motion.div
                      variants={animFade3}
                      className="content post-content px-120 lgscreen:px-30 max-w-[1100px] mx-auto"
                    >
                      {parse(post.content)}
                    </motion.div>
                  )}
                  <motion.div
                    variants={animFade3}
                    className="sicon relative flex flex-wrap justify-center mt-30 pt-30"
                  >
                    <motion.div variants={animFade3}>
                      <span className="text-19 tracking-05em uppercase">
                        Share this story:
                      </span>
                    </motion.div>
                    <ul className="share-social sicon flex flex-wrap items-center gap-x-2 ml-15">
                      <motion.li variants={animFade3}>
                        <Link
                          to={`mailto:?Subject=${post.title}&Body=${process.env.GATSBY_API_URL}${post.uri}`}
                          title="Mail to"
                          target="_blank"
                        >
                          <img
                            src="/images/Mail.svg"
                            className="relative -top-2"
                            width={27}
                            height={27}
                            loading="lazy"
                            alt="mail"
                          />
                        </Link>
                      </motion.li>
                      <motion.li variants={animFade3}>
                        <Link
                          to={`https://www.facebook.com/sharer/sharer.php?u=${process.env.GATSBY_API_URL}${post.uri}`}
                          title="Facebook"
                          target="_blank"
                        >
                          <img
                            src="/images/facebook.svg"
                            className="relative -top-2"
                            width={27}
                            height={27}
                            loading="lazy"
                            alt="facebook"
                          />
                        </Link>
                      </motion.li>
                    </ul>
                  </motion.div>

                  <motion.div
                    variants={animFade3}
                    className="pagination paginationSingle xl:mt-50 lg:mt-50 mt-20 px-120 lgscreen:px-30 pt-30 pb-50"
                  >
                    <ul className="flex flex-wrap !justify-between smscreen2:!justify-center gap-x-2 gap-y-2">
                      <motion.li
                        variants={animFade3}
                        className={`prev smscreen:w-full ${
                          prevPageCursor === "" ? " disabled" : ""
                        }`}
                      >
                        {prevPageCursor === "" ? (
                          <Link
                            to="#"
                            className="btn btn-border flex flex-wrap items-center gap-x-2"
                          >
                            <img
                              src="/images/prev-disable.svg"
                              width={16}
                              height={16}
                              className="relative -top-2"
                              loading="lazy"
                              alt="previous Post"
                            />
                            <p className="text-14 tracking-05em">
                              previous Post
                            </p>
                          </Link>
                        ) : (
                          <Link
                            to={prevPageCursor}
                            className="pre-enable btn btn-border flex flex-wrap items-center gap-x-2"
                          >
                            <img
                              src="/images/prev-disable.svg"
                              className="relative -top-2"
                              width={16}
                              height={16}
                              loading="lazy"
                              alt="previous Post"
                            />
                            <p className="text-14 tracking-05em">
                              previous Post
                            </p>
                          </Link>
                        )}
                      </motion.li>
                      <motion.li
                        variants={animFade3}
                        className={`next smscreen:w-full ${
                          nextPageCursor === "" ? " disabled" : ""
                        }`}
                      >
                        {nextPageCursor === "" ? (
                          <Link
                            to="#"
                            className="next-disable btn btn-border flex flex-wrap items-center gap-x-2"
                          >
                            <p className="text-14 tracking-05em">next post</p>
                            <img
                              src="/images/next.svg"
                              className="relative -top-1"
                              width={16}
                              height={16}
                              loading="lazy"
                              alt="next post"
                            />
                          </Link>
                        ) : (
                          <Link
                            to={nextPageCursor}
                            className=" btn btn-border flex flex-wrap items-center gap-x-2"
                          >
                            <p className="text-14 tracking-05em">next post</p>
                            <img
                              src="/images/next.svg"
                              width={16}
                              height={16}
                              className="relative -top-1"
                              loading="lazy"
                              alt="next post"
                            />
                          </Link>
                        )}
                      </motion.li>
                    </ul>
                  </motion.div>
                </div>
              </div>
              <motion.div
                variants={animFade3}
                className="flex flex-wrap justify-center mt-100 mb-10 lgscreen:mt-50 lgscreen:mb-0 px-20"
              >
                <motion.div variants={animFade}>
                  <Link to="/our-journal" className="btn btn-border opacity-50">
                    Back to journal
                  </Link>
                </motion.div>
              </motion.div>
            </div>

            <motion.div
              variants={animFade3}
              className={`discover-card bg-stone pt-80 pb-60 lgscreen:py-30`}
            >
              <div className="container-fluid-lg">
                <div className="text-center">
                  {postData?.blogSingleRelatedCardsHeading && (
                    <motion.h2 variants={animFade}>
                      {postData.blogSingleRelatedCardsHeading}
                    </motion.h2>
                  )}
                  {postData?.blogSingleRelatedCardsDescription && (
                    <motion.div variants={animFade} className="content">
                      {parse(postData.blogSingleRelatedCardsDescription)}
                    </motion.div>
                  )}
                </div>
                <div className="relative mt-60 lgscreen:mt-30">
                  <Swiper
                    spaceBetween={30}
                    slidesPerView={"11"}
                    speed={1000}
                    pagination={{
                      clickable: false,
                    }}
                    breakpoints={{
                      0: {
                        slidesPerView: 1.5,
                        centeredSlides: true,
                      },
                      641: {
                        slidesPerView: 2,
                      },
                      1024: {
                        slidesPerView: 3,
                      },
                    }}
                    modules={[Autoplay, Navigation]}
                  >
                    {postData.cards.map((item, i) => {
                      if (
                        selectCards.filter(card => card === item.cardType)
                          .length > 0
                      ) {
                        return (
                          <SwiperSlide key={i}>
                            <motion.div variants={animFade}>
                              <Link
                                to={item.link.url}
                                className="img portrait"
                                target={item.link.target}
                              >
                                {item?.image && (
                                  <div className="img relative">
                                    <ImageOpt
                                      imgData={item.image.mediaItemUrl}
                                      imgAlt={item.image.altText}
                                      width={484}
                                      height={574}
                                      imgLoad="lazy"
                                    />
                                  </div>
                                )}
                                <div className="absolute top-50per translate-y-minus_50 w-full text-center z-9">
                                  <div className="title-white w-full max-w-[240px] mx-auto">
                                    <motion.h3 variants={animFade}>
                                      {" "}
                                      {item.title}
                                    </motion.h3>
                                  </div>
                                </div>
                              </Link>
                            </motion.div>
                          </SwiperSlide>
                        )
                      } else {
                        return ""
                      }
                    })}
                  </Swiper>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </motion.section>
      </Layout>
    </div>
  )
}

export default BlogTemplate
export const blogPostQuery = graphql`
  query blogById($id: String) {
    post: wpPost(id: { eq: $id }) {
      id
      title
      uri
      link
      content
      date(formatString: "D MMMM yyyy")
      excerpt
      featuredImage {
        node {
          altText
          mediaItemUrl
        }
      }
      blogContent {
        bannerImage {
          mediaItemUrl
        }
      }
      author {
        node {
          firstName
          lastName
        }
      }
      seo {
        metaDesc
        canonical
        opengraphDescription
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphTitle
        opengraphType
        opengraphUrl
        opengraphSiteName
        title
        twitterDescription
        twitterTitle
        opengraphImage {
          publicUrl
        }
        twitterImage {
          publicUrl
        }
      }
    }
    allWpPost(sort: { date: DESC }) {
      nodes {
        uri
      }
    }

    wp {
      fluxDnaSettings {
        fluxDna {
          blogSingleRelatedCardsHeading
          blogSingleRelatedCardsDescription
          blogSingleSelectRelatedCards
          cards {
            link {
              target
              title
              url
            }
            cardType
            image {
              altText
              mediaItemUrl
              publicUrl
            }
            title
          }
        }
      }
    }
  }
`
export const Head = ({ data }) => {
  const post = data.post
  return <Seo seo={post.seo} title={post.seo.title} description={post.seo.metaDesc} />
}
